import React from 'react';

import UploadProjectModalForm from '../UploadProjectModalForm';
import { WizardProps, WizardReturnType } from '../types';
import LoadingContent from '../LoadinContent';
import errorSetup from '../errorModalSetup';

const Wizard = ({
  pristine,
  invalid,
  onClose,
  uploadProject,
  environmentsList,
  uploadProjectState,
  change,
}: WizardProps): WizardReturnType => {
  const { isLoading, error, loaded } = uploadProjectState;

  const shouldDisplayUploadProject = !(loaded || isLoading || error);

  if (isLoading) {
    return {
      title: 'Uploading project…',
      content: <LoadingContent />,
      glyph: 'deployment-export',
    };
  }

  if (shouldDisplayUploadProject) {
    return {
      title: 'Upload Project',
      content: (
        <UploadProjectModalForm
          change={change}
          environmentsList={environmentsList}
        />
      ),
      primaryAction: {
        text: 'Upload',
        onClick: uploadProject,
        disabled: pristine || invalid,
        'data-test': 'upload-project-button',
        style: { borderRadius: '4px' },
      },
      secondaryActions: [
        {
          text: 'Cancel',
          onClick: onClose,
          'data-test': 'cancel-button',
        },
      ],
      glyph: 'deployment-export',
    };
  }

  if (loaded) {
    return {
      title: 'Uploaded successful',
      content: (
        <div data-test="success-view-content">
          Your project has successfully uploaded to environment.
        </div>
      ),
      primaryAction: {
        text: 'Close',
        onClick: onClose,
        'data-test': 'cancel-button',
        style: { borderRadius: '4px' },
      },
      glyph: 'notification-verify',
      variant: 'success',
    };
  }

  return errorSetup(onClose);
};

export default Wizard;
